import AsyncStorage from '@react-native-community/async-storage'
import storage from 'redux-persist/lib/storage'
import ExpoFileSystemStorage from "redux-persist-expo-filesystem"
import { Platform } from 'react-native'

// const MFStorage = Platform.OS === 'ios' ? ExpoFileSystemStorage : AsyncStorage
const MFStorage = Platform.OS === 'web' ? storage : ExpoFileSystemStorage
export default MFStorage